__webpack_require__.p = "/quran/";